import { render, staticRenderFns } from "./FindVFairs.vue?vue&type=template&id=44e532ba&scoped=true&"
import script from "./FindVFairs.vue?vue&type=script&lang=js&"
export * from "./FindVFairs.vue?vue&type=script&lang=js&"
import style0 from "./FindVFairs.vue?vue&type=style&index=0&id=44e532ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e532ba",
  null
  
)

export default component.exports